document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".inner-banner-wrap, .index-banner-wrap")) {
    document.body.classList.add("has-inner-banner");
  }
});


$('.explore-slider').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button aria-label="slick-arrow-prev" type="button" class="slick-prev"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5312 2.25099L9.04864 0.84375L0.973257 8.5132C0.843085 8.63609 0.73978 8.78222 0.669286 8.94319C0.598791 9.10416 0.5625 9.27679 0.5625 9.45113C0.5625 9.62548 0.598791 9.7981 0.669286 9.95907C0.73978 10.12 0.843085 10.2662 0.973257 10.3891L9.04864 18.0625L10.5299 16.6553L2.95053 9.45312L10.5312 2.25099Z" fill="white"/></svg></button>',
  nextArrow: '<button aria-label="slick-arrow-next" type="button" class="slick-next"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.46875 2.25099L1.95136 0.84375L10.0267 8.5132C10.1569 8.63609 10.2602 8.78222 10.3307 8.94319C10.4012 9.10416 10.4375 9.27679 10.4375 9.45113C10.4375 9.62548 10.4012 9.7981 10.3307 9.95907C10.2602 10.12 10.1569 10.2662 10.0267 10.3891L1.95136 18.0625L0.470147 16.6553L8.04947 9.45312L0.46875 2.25099Z" fill="white"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});


$('.testimonial-slider').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<button aria-label="slick-arrow-prev" type="button" class="slick-prev"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5312 2.25099L9.04864 0.84375L0.973257 8.5132C0.843085 8.63609 0.73978 8.78222 0.669286 8.94319C0.598791 9.10416 0.5625 9.27679 0.5625 9.45113C0.5625 9.62548 0.598791 9.7981 0.669286 9.95907C0.73978 10.12 0.843085 10.2662 0.973257 10.3891L9.04864 18.0625L10.5299 16.6553L2.95053 9.45312L10.5312 2.25099Z" fill="white"/></svg></button>',
  nextArrow: '<button aria-label="slick-arrow-next" type="button" class="slick-next"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.46875 2.25099L1.95136 0.84375L10.0267 8.5132C10.1569 8.63609 10.2602 8.78222 10.3307 8.94319C10.4012 9.10416 10.4375 9.27679 10.4375 9.45113C10.4375 9.62548 10.4012 9.7981 10.3307 9.95907C10.2602 10.12 10.1569 10.2662 10.0267 10.3891L1.95136 18.0625L0.470147 16.6553L8.04947 9.45312L0.46875 2.25099Z" fill="white"/></svg></button>'
});



$('#categorySelect').on('change', function () {
    var DataLink = $(this).find(':selected').attr('data-link');
    location.href = DataLink;
      
});
setTimeout(function() {
        var FullUrl = location.href;
        var Fpath = new URL(FullUrl).pathname;
         $('#categorySelect option').each(function () {
            let OptionData = $(this).attr('data-link');
            if (Fpath == OptionData){
              $(this).attr("selected", "true"); 
              $(this).siblings().attr("selected", false);
            }
          });
      
}, 1500);


//product page
 $(".product-form__quantity, .buy-btn-wrap").wrapAll('<div class="qty-buy-wrap"></div>');		



//faq page
  $(".cmn-tab").click(function(){
      // tab menu active class add
       $(this).addClass("active");
       $(this).siblings().removeClass("active");

       // tab content active class add
       let tabId = $(this).attr("data-id");

        $(this).parent().next().children().each(function(){
           let TabcontId = $(this).attr("data-id");
            if (tabId == TabcontId){
               $(this).show();
               $(this).addClass("active");
               $(this).siblings().hide();
               $(this).siblings().removeClass("active");
            }          
        });
       
    });

    
  $(".faq-heading").click(function () {
    $(this).parent(".faq-block-items").toggleClass("active");
    $(this).next(".faq-text").slideToggle();
     $(this).parent(".faq-block-items").siblings().removeClass("active");
     $(this).parent(".faq-block-items").siblings().find(".faq-text").slideUp();
  });



// product page faq
 $('.faq-title').click(function () {
      if (!$(this).hasClass('active')) {
        $('.faq-title').removeClass('active');
        $('.faq-content').slideUp();
        $('.icon-plus').show(); 
        $('.icon-minus').hide(); 

        $(this).addClass('active');
        $(this).next('.faq-content').slideDown();
        $(this).find('.icon-plus').hide(); 
        $(this).find('.icon-minus').show(); 
      } else {
        
        $(this).removeClass('active');
        $(this).next('.faq-content').slideUp();
        $(this).find('.icon-plus').show(); 
        $(this).find('.icon-minus').hide(); 
      }
    });

    $('.faq-content').not(':first').hide(); 
    $('.faq-title:first').addClass('active');
    $('.faq-title:first .icon-plus').hide(); 
    $('.faq-title:first .icon-minus').show();



// product page tab

 $('.product-content.active').show();
    $('.tab').click(function () {
      var tabIndex = $(this).data("tab");
      $('.tab').removeClass('active');
      $('.product-content').removeClass('active').hide();
      $(this).addClass('active');
      $('.product-content[data-content="' + tabIndex + '"]').addClass('active').show();
    });


